import { useState } from 'react';
import { User as UserIcon } from 'lucide-react';
import type { User } from '@auth0/auth0-react';

interface AvatarProps {
  user?: User | null;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  fallback?: React.ReactNode;
}

export function Avatar({ user, size = 'md', className = '', fallback }: AvatarProps) {
  const [imageError, setImageError] = useState(false);
  
  const sizeClasses = {
    xs: 'h-4 w-4',
    sm: 'h-6 w-6',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16'
  };
  
  const iconSizes = {
    xs: 'h-2 w-2',
    sm: 'h-3 w-3',
    md: 'h-4 w-4',
    lg: 'h-6 w-6',
    xl: 'h-8 w-8'
  };
  
  return (
    <div className={`${sizeClasses[size]} rounded-full bg-primary text-on-primary flex items-center justify-center overflow-hidden ${className}`}>
      {user?.picture && !imageError ? (
        <img 
          src={user.picture} 
          alt={user.name || 'Photo de profil'} 
          className="h-full w-full object-cover"
          onError={() => setImageError(true)}
        />
      ) : fallback ? (
        fallback
      ) : (
        <UserIcon className={iconSizes[size]} />
      )}
    </div>
  );
}
